import { render } from "./UnitCirclePractice.vue?vue&type=template&id=457c5a7c"
import script from "./UnitCirclePractice.vue?vue&type=script&lang=js"
export * from "./UnitCirclePractice.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__